import { DiscordJS } from './DiscordJS'
import { ErisJS } from './ErisJS'
import { OceanicJS } from './OceanicJS'
import { Seyfert } from './Seyfert'

/**
 * Import example:
 * @example
 * ```ts
 * new Plugin.DiscordJS(client)
 * new Plugin.ErisJS(client)
 * new Plugin.OceanicJS(client)
 * new Plugin.Seyfert(client)
 * ```
 */
export default {
	DiscordJS,
	ErisJS,
	OceanicJS,
	Seyfert,
}
